'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatRelative;
var formatRelativeLocale = {
  lastWeek: '[last] dddd [at] LT',
  yesterday: '[yesterday at] LT',
  today: '[today at] LT',
  tomorrow: '[tomorrow at] LT',
  nextWeek: 'dddd [at] LT',
  other: 'L'
};

function formatRelative(token, date, baseDate, options) {
  return formatRelativeLocale[token];
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/date-fns/locale/en-US/_lib/formatRelative/index.js
// module id = ../../node_modules/date-fns/locale/en-US/_lib/formatRelative/index.js
// module chunks = 6